import React, { useContext, useEffect, useState } from "react";
import { LoadScript } from "@react-google-maps/api";
import Location from "../../../assets/svgs/Location.svg";
import UserLocation from "../../../assets/svgs/UserLocation.svg";
import Coordinates from "../../../interfaces/Coordinates.interface";
import { ButtonTypes } from "../../../interfaces/enums/ButtonTypes.enum";
import { QueryParams } from "../../../interfaces/enums/QueryParams.enum";
import setQueryParameters from "../../../utils/setQueryParameters.util";
import Button from "../../atoms/Button/Button.component";
// import getPostCode from "../../../utils/getPostCode.util"
import { useLocation } from "@reach/router";
import { navigate } from "gatsby";
import { VenueIndexSearchBarProps } from "../../../interfaces/VenueIndex/VenueIndex.interface";
import getLatLng from "../../../utils/getLatLng.util";
import VenuesContext from "../../../contexts/VenuesContext";
import getQueryParameters from "../../../utils/getQueryParameters.util";

enum Type {
  small = "small",
  large = "large",
}

const VenueIndexSearchBar: React.FC<VenueIndexSearchBarProps> = ({
  preSelectedFilters,
  placeholder_text,
  button,
  type = Type.large,
  btnId,
}) => {
  const [searchBarInputValue, setSearchBarInputValue] = useState("");
  const [isFetchingCurrentUserPostcode, setIsFetchingCurrentUserPostcode] = useState<boolean>(false);
  const location = useLocation();
  const venueData = useContext(VenuesContext);

  useEffect(() => {
    if (!getQueryParameters(QueryParams.LAT_LNG) && !getQueryParameters(QueryParams.SEARCH)) {
      setSearchBarInputValue("");
    } else {
      getQueryParameters(QueryParams.SEARCH) &&
        setSearchBarInputValue(decodeURI(getQueryParameters(QueryParams.SEARCH)));
    }
  }, [getQueryParameters(QueryParams.LAT_LNG)]);

  const getCurrentUserLocation = async (): Promise<void> => {
    if (!isFetchingCurrentUserPostcode) {
      setIsFetchingCurrentUserPostcode(true);
      navigator.geolocation.getCurrentPosition(position => {
        if (location.href.includes("/find-us")) {
          setIsFetchingCurrentUserPostcode(false);
          setQueryParameters(`${position.coords.latitude},${position.coords.longitude}`, QueryParams.LAT_LNG);
        } else {
          navigate(`/find-us?${QueryParams.LAT_LNG}=${position.coords.latitude},${position.coords.longitude}`);
        }
      });
    }
  };
  //

  const searchClubs = async (e?: any) => {
    const result: { coordinates: Coordinates } | undefined = await getLatLng(searchBarInputValue);

    const matchedVenues = venueData.filter(venue =>
      venue?.name?.toLowerCase().includes(searchBarInputValue.toLowerCase()),
    );
    if (matchedVenues.length > 0) {
      if (location.href.includes("/find-us")) {
        setQueryParameters(encodeURI(searchBarInputValue), QueryParams.SEARCH);
      } else {
        if (preSelectedFilters && preSelectedFilters.length) {
          navigate(
            `/find-us?${QueryParams.SEARCH}=${encodeURI(searchBarInputValue)}&${QueryParams.FILTERS}=${encodeURI(
              preSelectedFilters.map(filter => filter.replace("-", " ")),
            )}
          `,
          );
        } else {
          navigate(`/find-us?${QueryParams.SEARCH}=${encodeURI(searchBarInputValue)}`);
        }
      }
    } else {
      if (location.href.includes("/find-us")) {
        if (result?.coordinates?.lat && result?.coordinates?.lng) {
          setQueryParameters(`${result.coordinates.lat},${result.coordinates.lng}`, QueryParams.LAT_LNG);
        } else {
          setQueryParameters(`null`, QueryParams.LAT_LNG);
        }
      } else {
        if (result?.coordinates?.lat && result?.coordinates?.lng) {
          if (preSelectedFilters && preSelectedFilters.length) {
            navigate(
              `/find-us?${QueryParams.LAT_LNG}=${result.coordinates.lat},${result.coordinates.lng}&${
                QueryParams.FILTERS
              }=${encodeURI(preSelectedFilters.map(filter => filter.replace("-", " ")))}`,
            );
          } else {
            navigate(`/find-us?${QueryParams.LAT_LNG}=${result.coordinates.lat},${result.coordinates.lng}`);
          }
        } else {
          if (preSelectedFilters && preSelectedFilters.length) {
            navigate(
              `/find-us?${QueryParams.FILTERS}=${encodeURI(
                preSelectedFilters.map(filter => filter.replace("-", " ")),
              )}&${QueryParams.LAT_LNG}=null`,
            );
          } else {
          }
          navigate(
            `/find-us?${QueryParams.LAT_LNG}=null
            `,
          );
        }
      }
    }
  };

  const handleKeyPress = async (e: any) => {
    const FindClubsBtn = document.querySelector(`#${btnId}`);
    if (e.key == "Enter" && FindClubsBtn) {
      searchClubs(e);
    }
  };

  return (
    <div
      className={`col-span-6 col-start-4 items-center justify-center ${
        type === Type.large
          ? "md:flex sm:min-w-[35rem] md:drop-shadow-lg space-y-2 md:space-y-0 h-[48px] md:h-[56px] lg:h-[60px] 2xl:h-[64px]"
          : "flex flex-col lg:flex-row lg:min-w-[28rem] xl:min-w-[35rem] space-y-2 lg:space-y-0 gap-y-0 lg:gap-y-0 h-[46px]"
      }`}
    >
      {placeholder_text && (
        <div
          className={`w-full flex h-full items-center bg-White ${
            type === Type.large
              ? "md:rounded-l-full md:rounded-r-none rounded-full"
              : "rounded-full lg:rounded-r-none border border-Body-Disabled"
          }`}
        >
          <div className="flex-shrink-0 ml-7">
            <Location className="text-Secondary-300 text-sherpa-red-550" />
          </div>
          {!isFetchingCurrentUserPostcode && (
            <input
              onChange={e => setSearchBarInputValue(e.target.value)}
              onKeyDown={e => handleKeyPress(e)}
              value={searchBarInputValue}
              type="text"
              placeholder={placeholder_text}
              id={`${btnId}-input`}
              className={`${
                type === Type.large
                  ? "text-sm md:text-base 2xl:text-lg px-4 leading-6"
                  : "text-sm px-4 lg:pr-2 leading-4"
              } h-full flex-1 flex items-center focus:ring-0 focus:outline-none placeholder-Primary-900 bg-transparent`}
            />
          )}
          {isFetchingCurrentUserPostcode && (
            <p
              className={`${
                type === Type.large
                  ? "text-sm md:text-base 2xl:text-lg px-4 leading-6"
                  : "text-sm px-4 lg:pr-2 leading-4"
              } text-Primary-900 h-full flex-1 flex items-center`}
            >
              Finding your location...
            </p>
          )}
          <button
            onClick={() => getCurrentUserLocation()}
            aria-label="My location"
            className={`flex-shrink-0 mr-4 h-full flex items-center ${isFetchingCurrentUserPostcode && "pointer-events-none"}`}
          >
            <UserLocation
              className={`text-Primary-900 scale-[0.8] ${
                isFetchingCurrentUserPostcode && "animate-spin"
              } ${type === Type.small ? "scale-[0.7]" : "lg:scale-90 3xl:scale-100"}`}
            ></UserLocation>
          </button>
        </div>
      )}
      {button?.length && button[0]?.label && (
        <Button
          label={button[0].label ?? "Find clubs"}
          type={ButtonTypes.WITH_INPUT}
          className={`whitespace-nowrap h-full flex items-center justify-center !py-0 ${!searchBarInputValue && "pointer-events-none"} ${
            isFetchingCurrentUserPostcode && "pointer-events-none"
          } ${
            type === Type.small
              ? "!text-sm lg:!text-xs px-[1.25rem] !rounded-full lg:!rounded-l-none !w-full lg:!w-auto"
              : "md:rounded-r-full md:rounded-l-none"
          }`}
          onClick={async () => {
            if (searchBarInputValue) {
              searchClubs();
            }
          }}
          id={btnId}
        ></Button>
      )}
      <div className="hidden">
        <LoadScript googleMapsApiKey={process.env.GATSBY_GOOGLE_MAPS_API_KEY}></LoadScript>
      </div>
    </div>
  );
};

export default VenueIndexSearchBar;
